import type { SVGProps } from "react";
export interface KeyboardUpIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function KeyboardUpIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: KeyboardUpIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14 9.875a1.125 1.125 0 0 1 0 2.25h-4a1.125 1.125 0 0 1 0-2.25zm5.375 1.124a1.375 1.375 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 18 9.625l.141.008c.693.07 1.233.655 1.234 1.367Zm-12 0a1.375 1.375 0 0 1-2.743.141L4.625 11l.007-.141A1.375 1.375 0 0 1 6 9.625l.141.008c.693.07 1.233.655 1.234 1.367Zm0-3.999a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 6 5.625l.141.007A1.376 1.376 0 0 1 7.375 7m4 0a1.375 1.375 0 0 1-2.742.141l-.008-.14.008-.141A1.375 1.375 0 0 1 10 5.625l.14.007c.694.07 1.235.656 1.235 1.368m4 0a1.375 1.375 0 0 1-2.743.141l-.008-.14.008-.141A1.375 1.375 0 0 1 14 5.625l.14.007c.694.07 1.236.657 1.236 1.368Zm4 0a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 18 5.625l.141.007A1.376 1.376 0 0 1 19.375 7"
      />
      <path
        fill={color}
        d="M11.19 19.036a2.13 2.13 0 0 1 1.62 0l.252.124 1.5.866.097.061a1.126 1.126 0 0 1-1.119 1.94l-.102-.053-1.439-.83-1.437.83-.102.053a1.125 1.125 0 0 1-1.022-2.001l1.5-.866zM20.875 6c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v6c0 1.036.84 1.875 1.875 1.875h14c1.035 0 1.875-.84 1.875-1.875zm2.25 6A4.125 4.125 0 0 1 19 16.125H5A4.125 4.125 0 0 1 .875 12V6A4.125 4.125 0 0 1 5 1.875h14A4.125 4.125 0 0 1 23.125 6z"
      />
    </svg>
  );
}
